<template>
  <vgloballayout :loading="false" :error="error">
    <div slot="body">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="12"><h1>Лицевые счета</h1></el-col>
      </el-row>

      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline m-t-30"
        @submit.native.prevent="onSubmit"
      >
        <el-form-item label="Лицевой счет">
          <el-input
            v-model="form.accountName"
            size="small"
            placeholder="Введите лицевой счет"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSubmit"
            >Найти</el-button
          >
        </el-form-item>
      </el-form>

      <el-table
        v-loading="loading"
        empty-text="Записи отсутствуют"
        style="width: 100%"
        :data="dataAccounts"
      >
        <el-table-column label="id" width="100" prop="id"> </el-table-column>

        <el-table-column label="Номер ЛС" width="200" prop="accountName">
        </el-table-column>

        <el-table-column label="Бумажные квитанции" width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.invoiceDisabled ? "Отписан" : "Подписан" }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Адрес" prop="fullAddress"> </el-table-column>

        <el-table-column width="140">
          <template slot-scope="scope">
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-button size="mini" @click="openAccount(scope.row)">
                Подробнее
              </el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </vgloballayout>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      error: false,
      form: {
        accountName: ""
      },
      dataAccounts: []
    };
  },
  computed: {},
  mounted() {},
  methods: {
    async onSubmit() {
      this.loading = true;
      this.error = false;

      try {
        this.dataAccounts = await this.$store.dispatch(
          "getAccounts",
          this.form
        );
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }

      this.loading = false;
    },

    openAccount({ id }) {
      this.$router.push({ path: `/accounts/${id}` });
    }
  },
  components: {}
};
</script>
